import type { PlanEducationIconId } from './planEducationIcons'

/** "Keep your portfolio in top form" rows for the Rebalance timer shell. */
export const REBALANCE_FEATURE_ROWS = [
  {
    iconId: 'maximizingReturns' as const satisfies PlanEducationIconId,
    title: 'Performance optimisation',
    caption: 'by switching to better-performing funds'
  },
  {
    iconId: 'taxOptimisations' as const satisfies PlanEducationIconId,
    title: 'Tax-efficient moves',
    caption: 'that minimise the cost impact of exit load & tax'
  },
  {
    iconId: 'reviewedEveryMonth' as const satisfies PlanEducationIconId,
    title: 'Reviewed every month',
    caption: 'with rebalancing suggestions only when needed'
  }
] as const
